import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach token to every request automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, redirect to sign-in
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/auth/signin";
    }
    return Promise.reject(error);
  }
);

/** Upload image file; returns { data: { url } }. folder: services | products | addons | general */
export function uploadImage(file, folder = "services") {
  const formData = new FormData();
  formData.append("file", file);
  // Use a one-off request with no Content-Type so the browser sends multipart/form-data.
  // The api instance defaults to application/json, which causes 422 "field required".
  const token = localStorage.getItem("token");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  return axios.post(
    `${API_BASE_URL}/upload_image?folder=${encodeURIComponent(folder)}`,
    formData,
    { headers }
  );
}
// src/api/analytics.js


export async function fetchOrdersWeekdayCounts(params = {}) {
  const { month, sdate, edate, include_cancelled } = params;
  const { data } = await api.get("/admin/orders_weekday_counts", {
    params: {
      month,
      sdate,
      edate,
      include_cancelled: include_cancelled || false,
    },
  });
  return data; // { total_orders, by_weekday: [{weekday, count}] }
}

export async function fetchServicesWeeklyCounts(params = {}) {
  const { week_of = null, include_cancelled = false } = params;
  const { data } = await api.get("/admin/services_weekly_counts", {
    params: {
      week_of,                 // e.g., "2026-02-11"
      include_cancelled,       // boolean
    },
  });
  return data;
}

export async function fetchRevenueMonthly(params = {}) {
  const {
    year,                 // number (e.g., 2026)
    sdate,                // "YYYY-MM-DD" (optional)
    edate,                // "YYYY-MM-DD" (optional)
    include_pending = false, // boolean
  } = params;

  const { data } = await api.get("/admin/revenue_monthly", {
    params: {
      ...(year ? { year } : {}),
      ...(sdate ? { sdate } : {}),
      ...(edate ? { edate } : {}),
      include_pending,
    },
  });
  return data;
}


export default api;
